import { useEffect, useState } from "react";
import JwtFrame from "../../components/integration/JwtFrame";
import { BASE_API_URL } from "../../constants/api-path.c";
import Api from "../../utils/Api";
import { performRCP } from "../../utils/helper";
import RedirectNomupayHandler from "../../components/redirect-to-3ds-direct/RedirectToNomupay3DS";
import RedirectTo3DS from "../../components/redirect-to-3ds-direct/RedirectTo3DS";
import { RedirectSilverExpressHandler } from "../../components/redirect-to-3ds-direct/RedirectToSilverExpress3DS";
import { cardinalEnabledAcquirer } from "../../constants/common.c";
import "./style.css";
/**
 * This component is used to handle the integration of the direct payment.
 */

// Normal loader component that always shows the standard loader
export const Loader = () => {
  return (
    <div className="loader-container">
      <div className="spinner"></div>
    </div>
  );
};
const NOT_FOUND_PAGE = () => {
  return (
    <div className="not-found-message">
      <h1>404</h1>
      <p>Page Not Found</p>
    </div>
  );
};
const SERVER_ERROR_PAGE = () => {
  return (
    <div className="not-found-message">
      <h1>500</h1>
      <p>Something went wrong</p>
    </div>
  );
};

interface SilverExpressFormProps {
  type?: string;
  firstName: string;
  lastName: string;
  number: string;
  cvc: string;
  expiryMonth: string;
  expiryYear: string;
  aToken: string;
  oId: string;
  jsTranType: string;
}
const IntegrationPage = () => {
  //const [paymentResponse, setPaymentResponse] = useState<any>(null);
  const queryParams = new URLSearchParams(window.location.search);
  const [jwtToken, setJwtToken] = useState<string | null>(null);
  const [binNo, setBinNo] = useState<string | null>(null);
  const [binidentifier, setBinidentifier] = useState<string>("");
  const [nomupayContent, setNomupayContent] = useState();
  const [silverexpressContent, setSilverExpressContent] = useState<SilverExpressFormProps>();
  const [htmlContent, setHtmlContent] = useState("");
  const [isCardinalAPIExecuted, setCardinalAPIExecuted] = useState(false);
  const [showNotFound, setShowNotFound] = useState(false);
  const [showServerError, setShowServerError] = useState(false);
  useEffect(() => {
    // Set custom page title
    document.title = "Processing Payment";
    
    // Remove favicon by setting a blank data URL
    try {
      const favicon = document.querySelector("link[rel*='icon']") as HTMLLinkElement;
        if (favicon) {
          favicon.href = "data:image/x-icon;base64,";
        }
    } catch (error) {}
    
    try {
      const jToken = queryParams.get("_token");
      if (!jToken) {
        setShowNotFound(true);
        return;
      }
      const cardNumber = queryParams.get("_c");
      const _a: any = queryParams.get("_a")
      const binidentifier = atob(_a);
      setJwtToken(jToken);
      setBinNo(cardNumber);
      setBinidentifier(binidentifier);
    } catch (error) {
      setShowNotFound(true);
    }

    const CARDINAL_API_URL = `${BASE_API_URL}/paymentv2/set-session`;

    const messageHandler = async (event: MessageEvent) => {


      // This is a Cardinal Commerce URL in live.
      if (event.origin === process.env.REACT_APP_PUBLIC_CARDINAL_URL) {
        try {
          const data = JSON.parse(event.data);

          if (data && data.Status) {

            const paymentSessionID = data.SessionId;
            const paymentJSON = {
              "cardinal_session_id": paymentSessionID,
              "jwtToken": jwtToken
            };
            if (jwtToken && !isCardinalAPIExecuted) {
              await Api().post(CARDINAL_API_URL, paymentJSON).then((result: any) => {
                setCardinalAPIExecuted(true)
                if (result?.jwt && result?.MID) {
                  performRCP(result?.jwt, result?.MID);
                }
                else {
                  //handle direct payment redirection to success/decline url
                  let redirect = result?.direct_payment?.redirect_url;
                  if (redirect) {
                    window.location.href = redirect;
                    return;
                  } else {
                    setShowNotFound(true)
                  }
                }
              });
            }

          }
        } catch (error) {
          setShowServerError(true)
        }
      }
    };

    if (cardinalEnabledAcquirer.includes(binidentifier)) {
      // Add the event listener
      window.addEventListener("message", messageHandler);
    }
    else {
      getAPICall(CARDINAL_API_URL);
    }

    // Cleanup on component unmount
    return () => {
      window.removeEventListener("message", messageHandler);
    };
  }, [jwtToken]);

  const getAPICall = (URL: string) => {
    const paymentJSON = {
      "cardinal_session_id": "",
      "jwtToken": jwtToken || queryParams.get("_token")
    };
    if (jwtToken && !isCardinalAPIExecuted) {
      setCardinalAPIExecuted(true)
      Api().post(URL, paymentJSON).then((result: any) => {
        try {
          // console.log("result", JSON.stringify(result), "binidentifier", binidentifier)
          if (result?.redirecturl && result?.additional_parameters && binidentifier == "silver_express") {
            setSilverExpressContent(result.additional_parameters);
            //setDasLoader(false);
          }
          else if (result?.redirecturl && result?.additional_parameters) {
            setNomupayContent(result);
            //setDasLoader(false);
          }
          else if (result?.redirect_url || result?.redirecturl) {
            let redirecturl = result?.redirect_url ? result?.redirect_url : result?.redirecturl
            window.location.href = redirecturl;
          }
          else {
            //handle direct payment redirection to success/decline url
            let redirect = result?.direct_payment?.redirect_url;
            if (redirect) {
              window.location.href = redirect;
              return;
            } else {
              setShowNotFound(true)
            }
          }
        } catch (error) {
          setShowServerError(true)
        }
      });
    }
  }

  return (
    <div style={{ width: "100%", height: "100%", display: "block" }}>
      {showNotFound ? (
        <NOT_FOUND_PAGE />
      ) :
        showServerError ? (
          <SERVER_ERROR_PAGE />
        ) :
          (
            <>
              <Loader />
              {cardinalEnabledAcquirer.includes(binidentifier) &&
                <JwtFrame jwt={jwtToken} bin={binNo} />
              }
              {nomupayContent &&
                <RedirectNomupayHandler result={nomupayContent} />
              }
              {silverexpressContent &&
                <RedirectSilverExpressHandler result={silverexpressContent} />
              }
              {
                htmlContent &&
                <RedirectTo3DS htmlContent={htmlContent} />
              }
            </>
          )}
    </div>
  );
};

export default IntegrationPage;

